<template>
  <div class="page-form-wrap">
    <div class="page-form-cancel">
      <b-btn class="page-cancel-button"
             variant="link"
             type="submit"
             to="/reports">
        <svg-icon name="close" /> Cancel
      </b-btn>
    </div>
    <div class="page-form-header">
      <h1>Order #{{ report.id }}</h1>
    </div>
    <div class="page-form-content">
      <div class="form-order-info">
        <b-form-group>
          <div>Status</div>
          <strong>
            <report-status-text :status="report.status" :labworkType="report.labworkType" />
          </strong>
        </b-form-group>
        <div class="d-flex">
          <upload-file :url="`/server/labcorp/upload/labcorp-result?reportId=${reportId}`"
                       @file-uploaded="labcorpResultUploaded" />
          <b-btn v-if="report.hasLabcorpResult" class="ml-2" variant="link" @click="downloadLabcorpResult()">Download labcorp result</b-btn>
        </div>
      </div>
      <apob-final-report-form v-if="isApoBReport" />
      <ldlp-final-report-form v-if="!isApoBReport && isCraReport" />
      <advanced-final-report-form v-if="isAdvancedReport" />
      <dra-final-report-form v-else-if="!isCraReport" />
</div>
  </div>
</template>

<script>
  import formMixin from 'mixins/form-mixin';
  import finalReportFormMixin from 'mixins/final-report-form-mixin';

  import reportStatusText from './report-status-text';

  import reportStatus from 'enums/report-status';

  import labcorpService from 'services/labcorp-service';

  import apobFinalReportForm from './final-report-forms/apob-final-report-form'
  import draFinalReportForm from './final-report-forms/dra-final-report-form'
  import ldlpFinalReportForm from './final-report-forms/ldlp-final-report-form'
  import advancedFinalReportForm from './final-report-forms/advanced-final-report-form'

  export default {
    mixins: [formMixin, finalReportFormMixin],

    components: {
      reportStatusText,
      apobFinalReportForm,
      ldlpFinalReportForm,
      draFinalReportForm,
      advancedFinalReportForm
    },

    data() {
      return {
        reportStatus
      }
    },

    computed: {
      onlyView() { return this.report.status == reportStatus.Completed || this.report.assigneeId != this.$auth.id }
    },

    methods: {
      labcorpResultUploaded() {
        this.$root.successToast("Labcorp result uploaded!");
        this.report.hasLabcorpResult = true;
      },

      async downloadLabcorpResult() {
        await labcorpService.downloadLabcorpResult(this.reportId);
      }
    }
  };
</script>